import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CapabilityStatement from "./components/CapabilityStatement";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CapabilityStatement />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
